import createIcon from '../../createIcon';

/**
 * @component @name ScreenshotMonitor
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgM0g0QzIuODkgMyAyIDMuODkgMiA1VjE3QzIgMTguMSAyLjg5IDE5IDQgMTlIOFYyMUgxNlYxOUgyMEMyMS4xIDE5IDIyIDE4LjEgMjIgMTdWNUMyMiAzLjg5IDIxLjEgMyAyMCAzWk0yMCAxN0g0VjVIMjBWMTdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNi41IDcuNUg5VjZINVYxMEg2LjVWNy41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE5IDEySDE3LjVWMTQuNUgxNVYxNkgxOVYxMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ScreenshotMonitor = createIcon('ScreenshotMonitor', [
  [
    'path',
    {
      d: 'M20 3H4C2.89 3 2 3.89 2 5V17C2 18.1 2.89 19 4 19H8V21H16V19H20C21.1 19 22 18.1 22 17V5C22 3.89 21.1 3 20 3ZM20 17H4V5H20V17Z',
      key: 'a8w85l',
    },
  ],
  ['path', { d: 'M6.5 7.5H9V6H5V10H6.5V7.5Z', key: '1n5qpd' }],
  ['path', { d: 'M19 12H17.5V14.5H15V16H19V12Z', key: '14hu0u' }],
]);

export default ScreenshotMonitor;
